import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { AbstractCrudApiService } from '@shared/abstracts/abstract-crud-api.service';
import { urlJoin } from '@shared/utils/url.utils';
import { CreateTagDto, TagDto, TagReferencesDto } from '@shared/dto';

@Injectable({
  providedIn: 'root'
})
export class TagService extends AbstractCrudApiService<TagDto, CreateTagDto, CreateTagDto> {
  private readonly _base: string;

  constructor() {
    super();
    this._base = urlJoin(this.env.get('api.base'), 'tags');
    this.logger.debug(this.name, 'Endpoint', this.endpoint);
  }

  /**
   * `:tagId` is part of the endpoint so the by-id writes can fill it; `url()`
   * drops the placeholder segment when no params are given, which is what keeps
   * the plain list read on `/tags`.
   */
  get endpoint(): string {
    return `${this._base}/:tagId`;
  }

  /**
   * What a tag is attached to. Read on its own, never from the delete error:
   * the API answers 428 with a message that says a decision is needed and
   * nothing more, so the exercises have to be asked for separately.
   */
  readReferences(tagId: number): Observable<TagReferencesDto> {
    return this.http
      .get<TagReferencesDto>(`${this._base}/${tagId}/references`)
      .pipe(catchError((error) => this.handleHttpErrorResponse(error)));
  }
}
